
const currentDate = new Date();

// Increments value per each second since the start of the provided date
export function incrementValueFromDate(value: number, increment: number,  date: Date) {
  const diff = Math.abs(date.getTime() - currentDate.getTime());
  const seconds = Math.floor(diff / 1000);
  return Math.round(value + (seconds * increment));
}